<template>
  <div>
    <v-dialog v-model="dialog" scrollable persistent width="800px">
      <v-card>
        <v-card-title class="blue darken-4 white--text">
          <span class="text-center headline"> Registrar promocion </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="5">
                <p class="mb-0 mt-3 black--text">Tipo de aplicacion:</p>
                <v-divider class="my-0 black mb-2"></v-divider>
                <v-radio-group class="mt-0" v-model="input.tipo_aplicacion">
                  <v-radio v-for="n in tipos" :key="n.id" :label="n.text" :value="n" @click="ontipoclick()"></v-radio>
                </v-radio-group>

                <v-combobox v-model="item_unidad" :items="items_unidades" v-if="item_unidad" class="mb-4" hide-selected
                  hide-details label="Unidades a aplicar:" multiple item-text="nombre" outlined readonly color="green"
                  persistent-hint small-chips dense>
                </v-combobox>
                <v-combobox v-model="item_sede" :items="items_sedes" v-if="item_sede" class="mb-4" hide-selected
                  hide-details label="Sedes a aplicar:" multiple item-text="nombre" outlined readonly color="green"
                  persistent-hint small-chips dense>
                </v-combobox>
                <v-combobox v-model="item_programa" :items="items_programas" v-if="item_programa" class="mb-4"
                  hide-selected hide-details label="Programas a aplicar:" multiple item-text="nombre_compuesto" outlined
                  readonly color="green" persistent-hint small-chips dense>
                </v-combobox>
              </v-col>
              <v-col cols="12" sm="7">
                <v-text-field v-model.trim="input.nombre_promo" label="* Nombre de la promocion:" dense outlined />
                <v-textarea v-model.trim="input.descripcion" label="Descripcion" rows="2" dense outlined />
                <v-row>
                  <v-col cols="12" sm="5">
                    <v-text-field v-model="input.fecha_inicio" label="* Inicia" type="date" dense outlined hide-details
                      placeholder="fecha_inicio..." />
                  </v-col>

                  <v-col cols="12" sm="5">
                    <v-text-field v-model="input.fecha_fin" label="* Finaliza" type="date" dense outlined hide-details
                      placeholder="fecha_inicio..." />
                  </v-col>
                  <v-col cols="12" sm="2">
                    <v-btn color="green" outlined tile @click="agregarFechas()">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </v-col>
                  <v-row>
                    <v-data-table :headers="headersFecha" :items="fechas" :itemsPerPage="-1" class="elevation-2"
                      disable-pagination hide-default-footer>                     
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-tooltip bottom v-if="item.inscritos != 0">
                          <template #activator="{ on, attrs }">
                            <v-icon class="red--text" v-bind="attrs" v-on="on" @click="eliminarFecha(item)">
                              mdi-delete
                            </v-icon>
                          </template>
                          Eliminar promocion
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-row>
                </v-row>
              </v-col>
            </v-row>

            <v-btn color="green" small outlined tile @click="openConceptosmodal()">
              <v-icon left>mdi-plus</v-icon> Agregar conceptos
            </v-btn>
            <v-data-table :headers="headers" :items="conceptossels" :itemsPerPage="-1" class="elevation-2"
              disable-pagination hide-default-footer>
              <template v-slot:[`item.descuento`]="{ item }">
                <v-text-field v-model.number="item.descuento" class="end-input" dense outlined hide-details
                  type="number" :suffix="item.porcentual ? '%' : 'Bs.'" />
              </template>

              <template v-slot:[`item.porcentual`]="{ item }">
                <v-checkbox v-model="item.porcentual" :label="item.porcentual ? 'Porcentual' : 'Monto'"
                  @change="onchangetipo(item)" color="green" hide-details></v-checkbox>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip bottom v-if="item.inscritos != 0">
                  <template #activator="{ on, attrs }">
                    <v-icon class="red--text" v-bind="attrs" v-on="on" @click="eliminarconcepto(item)">
                      mdi-delete
                    </v-icon>
                  </template>
                  Eliminar promocion
                </v-tooltip>
              </template>
            </v-data-table>
          </v-container>

          <p class="text-center red--text">{{ msg }}</p>
          <v-progress-linear indeterminate v-if="loading" />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" rounded outlined @click="validar()">
            <v-icon class="mx-1">mdi-content-save</v-icon> Guardar</v-btn>
          <v-btn rounded outlined @click="dialog = !dialog"> <v-icon>mdi-close</v-icon> Cancelar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Conceptos ref="xconceptosmodal" v-on:conceptos_sel="conceptos_sel" />
    <Unidades ref="xunidadesmodal" v-on:cleartipo="cleartipo" v-on:unidades_sel="unidades_sel" />
    <Sedes ref="xsedesmodal" v-on:cleartipo="cleartipo" v-on:sedes_sel="sedes_sel" />
    <Programas ref="xprogramasmodal" v-on:cleartipo="cleartipo" v-on:programas_sel="programas_sel" />
  </div>
</template>

<style scoped>
.end-input>>>input {
  text-align: end;
}
</style>

<script>
import Conceptos from '@/views/promociones/listar-conceptos.vue';
import Unidades from '@/views/promociones/listar-unidades.vue';
import Sedes from '@/views/promociones/listar-sedes.vue';
import Programas from '@/views/promociones/listar-programas.vue';
import xaxios from '@/xaxios';
export default {
  data() {
    return {
      dialog: false,
      loading: false,
      msg: '',
      tipos: [
        { id: 1, text: 'General' },
        { id: 2, text: 'Por Unidad de Negocio' },
        { id: 3, text: 'Por Sede' },
        { id: 4, text: 'Por Programa' },
      ],
      input: {
        tipo_aplicacion: null,
        nombre_promo: '',
        descripcion: '',
        fecha_inicio: '',
        fecha_fin: '',
      },
      headers: [
        { text: '#', value: 'nro', width: 30 },
        { text: 'Concepto', value: 'nombre' },
        { text: 'Tipo descuento', value: 'porcentual', width: 150 },
        { text: 'Descuento', value: 'descuento', width: 150 },
        { text: '', value: 'actions', width: 130 },
      ],
      headersFecha: [
        { text: '#', value: 'nro' },
        { text: 'Inicia', value: 'fecha_inicio' },
        { text: 'Finaliza', value: 'fecha_fin' },
        { text: '', value: 'actions', width: 130 },
      ],

      conceptossels: [],
      fechas: [],
      items_unidades: [],
      item_unidad: null,
      items_sedes: [],
      item_sede: null,
      items_programas: [],
      item_programa: null,
    };
  },
  components: { Conceptos, Unidades, Sedes, Programas },
  computed: {},
  watch: {
    'input.tipo_aplicacion': function () {
      if (!this.input.tipo_aplicacion) return;
      this.ontipoclick();
    },
  },
  methods: {
    openmodal(item) {
      this.msg = '';
      this.form = Object.assign({}, item);
      this.input.nombre_promo = '';
      this.input.descripcion = '';
      this.input.fecha_inicio = '';
      this.input.fecha_fin = '';
      this.input.tipo_aplicacion = null;
      this.conceptossels = [];
      this.fechas = [];
      this.items_unidades = [];
      this.items_sedes = [];
      this.item_unidad = null;
      this.item_sede = null;
      this.item_programa = null;
      this.dialog = true;
      this.cleartipo();
    },
    openUnidadesmodal() {
      this.$refs.xunidadesmodal.openmodal();
    },
    openSedesmodal() {
      this.$refs.xsedesmodal.openmodal();
    },
    openProgramasmodal() {
      this.$refs.xprogramasmodal.openmodal();
    },
    openConceptosmodal() {
      this.$refs.xconceptosmodal.openmodal(this.item_unidad);
    },
    unidades_sel(units) {
      if (units.length > 0) {
        this.items_unidades = units;
        this.item_unidad = units;
      } else this.cleartipo();
      window.console.log(units);
    },
    sedes_sel(units) {
      if (units.length > 0) {
        this.items_sedes = units;
        this.item_sede = units;
      } else this.cleartipo();
      window.console.log(units);
    },
    programas_sel(units) {
      if (units.length > 0) {
        this.items_programas = units;
        this.item_programa = units;
      } else this.cleartipo();
      window.console.log(units);
    },
    conceptos_sel(units) {
      let datos = [];
      units.forEach((x, i) => {
        datos.push({ nro: i + 1, id: x.id, nombre: x.nombre, porcentual: false, descuento: 0 });
      });
      if (units.length > 0) {
        this.conceptossels = datos;
      }
      window.console.log(datos);
    },
    agregarFechas() {
      if (!this.input.fecha_inicio || !this.input.fecha_fin) {
        this.msg = 'Ingrese las fechas de inicio y fin de la promo.';
        return;
      }
      this.fechas.push({
        nro: this.fechas.length + 1,
        id: this.fechas.length + 1,
        fecha_inicio: this.input.fecha_inicio,
        fecha_fin: this.input.fecha_fin,
      });
      this.input.fecha_inicio = '';
      this.input.fecha_fin = '';
    },
    ontipoclick() {
      this.item_unidad = null;
      this.item_sede = null;
      this.item_programa = null;
      if (this.input.tipo_aplicacion.id == 2) this.openUnidadesmodal();
      if (this.input.tipo_aplicacion.id == 3) this.openSedesmodal();
      if (this.input.tipo_aplicacion.id == 4) this.openProgramasmodal();
    },
    cleartipo() {
      this.input.tipo_aplicacion = null;
    },
    eliminarconcepto(item) {
      this.conceptossels = this.conceptossels.filter((x) => x.id != item.id);
    },
    eliminarFecha(item) {
      this.fechas = this.fechas.filter((x) => x.id != item.id);
    },
    onchangetipo(item) {
      if (item.porcentual && item.descuento > 100) item.descuento = 100;
    },
    validar() {
      this.msg = '';
      let vue = this;
      if (this.conceptossels.length == 0) this.msg = 'Seleccione los conceptos.';
      if (this.fechas.length == 0) this.msg = 'Agregue las Fechas para la promo.';
      // if (!this.input.fecha_fin) this.msg = 'Ingrese la fecha de finalizacion de la promo.';
      // if (!this.input.fecha_inicio) this.msg = 'Ingrese la fecha de inicio de la promo.';
      if (!this.input.nombre_promo) this.msg = 'Ingrese el nombre de la promo.';
      if (!this.input.tipo_aplicacion) this.msg = 'Selecciona el tipo de aplicacion.';
      if (this.msg) return;

      let us = this.$store.state.DATA_USER;
      if (!us.seg_apellido) us.seg_apellido = '';
      let usuario = `${us.nombres} ${us.pri_apellido} ${us.seg_apellido}`.trim();

      let ambiente = 'coorporacion';
      let aplis = [];
      let pcon = [];
      if (this.input.tipo_aplicacion.id == 2) {
        ambiente = 'unidad_negocio';
        this.item_unidad.forEach((x) => {
          aplis.push({ nombre: x.nombre, codigo_id: x.id });
        });
      } else if (this.input.tipo_aplicacion.id == 3) {
        ambiente = 'sede';
        this.item_sede.forEach((x) => {
          aplis.push({ nombre: x.nombre, codigo_id: x.id });
        });
      } else if (this.input.tipo_aplicacion.id == 4) {
        ambiente = 'programa';
        this.item_programa.forEach((x) => {
          aplis.push({ nombre: x.nombre_compuesto, codigo_id: x.id });
        });
      }

      this.conceptossels.forEach((x) => {
        pcon.push({ concepto_pago_id: x.id, is_porcentaje: x.porcentual, valor_descuento: x.descuento });
        if (!x.descuento || x.descuento < 0) vue.msg = `valor de descuento (${x.descuento}) no permitido`;
      });
      if (this.msg) return;

      let deta = {
        ambiente: ambiente,
        detalle: aplis,
      };

      let payload = {
        nombre: this.input.nombre_promo,
        descripcion: this.input.descripcion,
        fecha_inicio: this.input.fecha_inicio,
        fecha_fin: this.input.fecha_fin,
        fechas: this.fechas,
        creado_por: usuario,
        ambiente: JSON.stringify(deta),
        detalle_promocion: pcon,
      };

      window.console.log(JSON.stringify(this.input, null, 4));
      window.console.log(JSON.stringify(payload, null, 4));

      /* let a = 5;
      if (a > 1) return; */

      var config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_REST}/api/v1/esam/promociones/masivo`,
        headers: {},
        data: payload,
      };

      xaxios.request(config)
        .then(function (response) {
          let data = response.data.data;
          window.console.log(response, data);
          vue.$emit('onnew', data);
          vue.dialog = false;
        })
        .catch(function (error) {
          window.console.log(error);
        });
    },
  },
};
</script>
